export default __webpack_public_path__ + "static/media/iconRecentesAlterado.173557a3.svg";